// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__0dtL1","section-heading":"section_section-heading__TZKTe","subtitle":"section_subtitle__LXO0V","centered":"section_centered__n_EqH"};